import React from 'react'
import cn from 'classnames'

import { ToggleSwitchProps } from './interface'

export const ToggleSwitch = ({
  checked,
  disabled = false,
  ...props
}: ToggleSwitchProps) => {
  return (
    <label className='cursor-pointer'>
      <div
        className={cn('toggle-switch relative', {
          'cursor-no-drop opacity-40': disabled,
        })}
      >
        <input
          type='checkbox'
          checked={checked}
          disabled={disabled}
          className='sr-only'
          {...props}
        />
        <div
          className={cn('block w-11 h-6 rounded-3xl', {
            'bg-primary': checked,
            'bg-gray-3 dark:bg-dark-10': !checked,
          })}
        />
        <div className='dot absolute left-[2px] top-[2px] bg-white dark:bg-white-2 w-5 h-5 rounded-full transition' />
      </div>
    </label>
  )
}
